"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIPopoverCloseButton = _interopRequireDefault(require("./UIPopoverCloseButton"));

var _PopoverContext = require("../context/PopoverContext");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n            border-top-right-radius: ", ";\n            border-top-left-radius: ", ";\n            color: ", ";\n            padding: ", " ", ";\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  && {\n    background: ", ";\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Header = _styledComponents.default.header.withConfig({
  displayName: "UIPopoverHeader__Header",
  componentId: "sc-1xacfb0-0"
})(_templateObject(), function (_ref) {
  var popoverUse = _ref.popoverUse;
  return popoverUse === 'shepherd' ? _colors.THUNDERDOME : 'inherit';
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;
  return popoverUse === 'shepherd' ? (0, _styledComponents.css)(_templateObject2(), _sizes.BUTTON_RADIUS, _sizes.BUTTON_RADIUS, _colors.OLAF, _sizes.SHEPHERD_PADDING_Y, _sizes.POPOVER_PADDING_X) : null;
});

function UIPopoverHeader(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      flush = _ref3.flush,
      onOpenChange = _ref3.onOpenChange,
      showCloseButton = _ref3.showCloseButton,
      popoverContext = _ref3.popoverContext,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["className", "children", "flush", "onOpenChange", "showCloseButton", "popoverContext"]);
  return _react.default.createElement(Header, (0, _extends2.default)({}, rest, {
    className: (0, _classNames.default)('uiPopoverHeader', 'private-popover__header', {
      'private-popover__header--flush': flush
    }, className),
    popoverUse: popoverContext.use
  }), children, showCloseButton && _react.default.createElement(_UIPopoverCloseButton.default, {
    popoverUse: popoverContext.use,
    onClick: function onClick() {
      return (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent.default)(false));
    }
  }));
}

UIPopoverHeader.propTypes = {
  children: _react.PropTypes.node,
  flush: _react.PropTypes.bool,
  showCloseButton: _react.PropTypes.bool,
  onOpenChange: _react.PropTypes.func,
  popoverContext: _PopoverContext.popoverContextPropType
};
UIPopoverHeader.displayName = 'UIPopoverHeader';

var _default = (0, _PopoverContext.ConsumesPopoverContext)(UIPopoverHeader);

exports.default = _default;
module.exports = exports.default;